import type { InlineGuidanceSegment } from '../config';

const INLINE_GUIDANCE = /\[[^[\]]*\]/g;

// Guidance inside fixed wording: a span in square brackets is
// passed to the model and never printed. The editor shows it apart from the
// wording and the preview leaves it out. A bracket without its pair stays
// wording; scribe warns about it.
export const splitInlineGuidance = (text: string): InlineGuidanceSegment[] => {
  const { segments, end } = [...text.matchAll(INLINE_GUIDANCE)].reduce<{
    segments: InlineGuidanceSegment[];
    end: number;
  }>(
    (acc, match) => {
      const start = match.index ?? 0;
      return {
        segments: [
          ...acc.segments,
          ...(start > acc.end
            ? [{ text: text.slice(acc.end, start), guidance: false }]
            : []),
          { text: match[0].slice(1, -1), guidance: true },
        ],
        end: start + match[0].length,
      };
    },
    { segments: [], end: 0 },
  );
  return end < text.length
    ? [...segments, { text: text.slice(end), guidance: false }]
    : segments;
};
